function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#121212",
  d: "M12.5 75h75v-8.333h-75V75zm0-20.833h75v-8.334h-75v8.334zM12.5 25v8.333h75V25h-75z"
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMi41IDc1SDg3LjVWNjYuNjY2N0gxMi41Vjc1Wk0xMi41IDU0LjE2NjdIODcuNVY0NS44MzMzSDEyLjVWNTQuMTY2N1pNMTIuNSAyNVYzMy4zMzMzSDg3LjVWMjVIMTIuNVoiIGZpbGw9IiMxMjEyMTIiLz4KPC9zdmc+Cg==";
export { SvgMenu as ReactComponent };